import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'Date',
        caption: 'Date',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        fixed: true,
        alignment: 'right',
        allowEditing: false,
    },
    {
        dataField: 'Time',
        caption: 'Time',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        fixed: true,
        alignment: 'right',
        allowEditing: false,
    },
    {
        dataField: 'Subject',
        caption: 'Subject',
        minWidth: COLUMN_SIZE.lg1,
        isEditable: false,
        allowEditing: true
    },
    {
        dataField: 'UserId',
        caption: 'User ID',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        allowEditing: false,
    },
    {
        dataField: 'Surname',
        caption: 'Surname',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        allowEditing: false
    },
    {
        dataField: 'FirstName',
        caption: 'First name',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        allowEditing: false,
    },
    {
        dataField: 'CommentFull',
        caption: 'Comment',
        minWidth: COLUMN_SIZE.lg1,
        isEditable: false,
        allowEditing: true
    },
    {
        dataField: 'SystemGeneratedDisplay',
        caption: 'System generated',
        width: COLUMN_SIZE.lg1,
        allowEditing: false,
    }
];
